import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";

/**
 * PLEASE NOTE:
 * Navigation guards are configured in `router/index.js`
 */
// Configure our routes
var routes = [{
  // Index page
  component: function component() {
    return import('pages/Index');
  },
  meta: {
    title: 'route.index'
  },
  path: '/'
}].concat(_toConsumableArray(require("./routes/checkIn").default), _toConsumableArray(require("./routes/checkout").default), _toConsumableArray(require("./routes/survey").default), _toConsumableArray(require("./routes/tablet").default), [// This should be defined with path: '*', but due to the silly way we currently start the survey
// (as 125surveys.com/{templateSlug} where templateSlug can be anything), we need the '*' route
// to go to pages/Index. As a result, we need to have a specific path for 404 and explicitly
// redirect to it when we need to :(
{
  path: '/error-404',
  component: function component() {
    return import('pages/Error404');
  },
  meta: {
    title: 'route.error404'
  }
}, {
  path: '*',
  component: function component() {
    return import('pages/Index');
  },
  meta: {
    slug: 'path'
  }
} // Slug search
]);
export default routes;